<!--  -->
<template>
	<div class="container">
		<div class="flex flex-container">
			<!--  -->
			<div class="flex-left">
				<div class="search-container flex flex-between">
					<div class="flex">
						<div class="mt5 ml5"><span class="red">*</span> 组织机构:</div>

						<el-select v-model="groupId" class="ml10 w280" size="small" placeholder="组织机构"
                           @change="handleGroup">
							<el-option v-for="item in groupDate" :key="item.groupId" :label="item.groupName"
								:value="item.groupId">
							</el-option>
						</el-select>
                         <!-- <img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch"  alt=""> -->
					</div>

				</div>
				<div class="mt10">
					<!-- :height="height" -->
					<el-table
						ref="multipleTable1"
						:data="tableData1"
						:height="height"
						:row-class-name="tabRowClassName"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
						border style="width: 100%">
						<el-table-column :show-overflow-tooltip="true" prop="skuName"  label="SKU" sortable>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="storeCode" label="仓库编码" sortable>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="storeName"  label="默认出货仓" sortable>
							<template slot-scope="scope">
								<el-select v-model="scope.row.gwId" class="w280" size="small" placeholder="请选择"  :disabled="isEdit?(scope.row.selectFlag):true"
									@change="handleStore(scope.row)">
										<el-option v-for="item in storeOption" :key="item.gwId" :label="item.storeName"
											:value="item.gwId">
										</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" label="强制【请选择】">
							<template #default="scope">
								<el-checkbox v-model="scope.row.selectFlag"  @change="handleSelectFlag(scope.$index,scope.row)" :disabled="isEdit?false:true"></el-checkbox>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!--  -->
		</div>

	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'warehouse',
		components: {

		},
		data() {
			return {
				height: 500,
				selecteId: '',
				currentData: '',
				pageNo: 1,
				pageSize: 40,
				tableData1: [],
				groupDate: [],
					groupId:"",
				isEdit:false,
				storeOption:[]
			}
		},
		created() {
			this.height = window.innerHeight - 170;
			this.getAgentSelectList()
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
			}
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},

            	// 组织结构
			getAgentSelectList() {
				let that = this;
				that.$request.post(
						"busSelectList",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.groupDate = res.data
                            that.groupId = res.data[0].groupId
							that.getList()
						}
					})
			},
            	// 组织结构处理
			handleGroup(val) {
				this.groupId=val
				this.getList()
			},

			// 获取列表
			getList() {
				let that = this;
				that.$request.post(
					"storeList",
					true, {
						groupId: that.groupId,
					}
				)
				.then((res) => {
					if (res) {
							that.tableData1 = res.data.map((item, index) => {
				  			if (item.selectFlag != null) {
									item["selectFlag"] = item.selectFlag == 1 ? true : false
								} else {
									item["selectFlag"] = false
								}
				  			return item
			  			})
					}
					that.getList1()
				})
			},
			// 获取列表
			getList1() {
				let that = this;
				that.$request.post(
					"wareList",
					true, {
						groupId: that.groupId,
					}
				)
				.then((res) => {
					if (res) {
							that.storeOption = res.data
					}
				})
			},
			// 选择出库仓名称
			handleStore(row){
				this.editWare(row)
			},
			editWare(row){
				let that = this;
				that.$request.post(
					"storeSetDefault",
					true, {
						skuId: row.skuId,
						gwId: row.gwId,
						gssId: row.gssId,
					}
				)
				.then((res) => {
					if (res) {
						that.$message.success("默认出货仓修改成功！");
						that.getList()
					}
				})
			},
			handleSelectFlag(index,row) {
		  let that = this;

		  if (!row.gssId) {
			  that.$message.error('请优先设置仓库!');
			  return
		  }
		  console.log(row.selectFlag)
		  that.$request.post(
			  "setSelectFlag",
			  true, {
				  selectFlag: row.selectFlag ? 1 : 0,
				  gssId: row.gssId,
			  }
		  )
			  .then((res) => {
				  if (res) {
					  that.$message.success(row.selectFlag ? "修改成功！" : "修改成功！");
				  }
			  })
	  }
		},
		beforeDestroy() {

		}
	}

</script>

<style lang='scss' scoped>
	.container {
		// width: 99%;
		box-sizing: border-box;
			margin: 12px 26px 15px 10px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.search-container {
		 background: #F9FAFD;
         padding: 5px;
	}

	.flex-container {
		width: 100%;
		align-items: flex-start;
		box-sizing: border-box;
	}

	.flex-left {
		width: 100%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}

	.flex-right {
		width: 43%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}
.title{
	line-height: 32px;
}
</style>
<style scoped>
.cursor{
	cursor: pointer;
}
>>> .el-radio {
  margin-left: 6px;
}
>>> .el-radio .el-radio__label {
  display: none;
}
.red{
	color: red;
}
.w280{
	width: 280px !important;
}
</style>
